var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumpy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77414 5.07966L5.66809 2.97176L1.16014 5.2596L5.37821 7.41352L9.77414 5.07966ZM11.6576 6.04602L15.963 8.25738L11.4963 10.5382L7.27163 8.38115L11.6576 6.04602ZM17.4084 3.00318L21.8321 5.2596L17.8752 7.27991L13.561 5.06633L17.4084 3.00318ZM15.504 2.03142L11.5215 0L7.58242 2L11.6863 4.10441L15.504 2.03142ZM12.3909 19.4725V25L17.2149 22.5513L17.2105 17.0216L12.3909 19.4725ZM17.2083 15.0917L17.2027 9.62044L12.3909 12.0536V17.5268L17.2083 15.0917ZM23 14.067V19.6157L18.8849 21.7033L18.8815 16.1803L23 14.067ZM23 12.1266V6.68931L18.8805 8.77341V14.2558L23 12.1266ZM10.6878 12.0536L7.43857 10.391V17.5719L3.09662 8.19867C3.04919 8.0987 2.85448 7.98953 2.80456 7.96255L0 6.50714V19.1984L2.88881 20.7731V14.1365L6.86131 21.9057C6.90218 21.9898 7.29472 22.7988 7.71722 23.0831C8.27794 23.4624 10.6856 24.9346 10.6856 24.9346L10.6878 12.0536Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumpy);
export default __webpack_public_path__ + "static/media/numpy.effad22d103764cbc83f8bcb443c4eaa.svg";
export { ForwardRef as ReactComponent };